import {override } from 'flarum/extend';
import IndexPage from 'flarum/components/IndexPage';

import WelcomeHero from '../../components/WelcomeHero';

export default function() {
  override(IndexPage.prototype, 'hero', function(original) {
    if (!m.route.param('tags')) {
      return WelcomeHero.component();
    }
    return original();
  });
}
